import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get movement List
export const getMovementlist = createAsyncThunk(
  "getMovementlist",
  async (
    { search, pageLimit, pageCount, sort_by, sort_direction },
    { rejectWithValue }
  ) => {
    try {
      let queryParams = [];

      if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
      if (pageCount) queryParams.push(`page=${pageCount}`);
      if (pageLimit) queryParams.push(`limit=${pageLimit}`);
      if (sort_by) queryParams.push(`sortBy=${sort_by}`);
      if (sort_direction) queryParams.push(`sortOrder=${sort_direction}`);

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await AxiosApi.get(
        `/movements/get-movement${queryString}`
      );
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Something went wrong"
      );
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

// Create movement
export const createMovement = createAsyncThunk(
  "createMovement",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`/movements/add-movement`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Create Edit movement
export const editMovement = createAsyncThunk(
  "editMovement",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`/movements/update-movement`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete movement
export const deleteMovement = createAsyncThunk(
  "deleteMovement",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(
        `/movements/delete-movement/${id}`
      );
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const movementSlice = createSlice({
  name: "movement",
  initialState: initialStates,

  extraReducers: (builder) => {
    builder
      // get movement list
      .addCase(getMovementlist.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMovementlist.fulfilled, (state, action) => {
        state.loading = false;
        state.getMovementlistStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getMovementlist.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      //create movement
      .addCase(createMovement.pending, (state) => {
        state.loading = true;
      })
      .addCase(createMovement.fulfilled, (state, action) => {
        state.loading = false;
        state.createMovementStatus.data = action.payload;
        state.error = false;
      })
      .addCase(createMovement.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      //edit movement
      .addCase(editMovement.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMovement.fulfilled, (state, action) => {
        state.loading = false;
        state.editMovementStatus.data = action.payload;
        state.error = false;
      })
      .addCase(editMovement.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })

      // Delete movement
      .addCase(deleteMovement.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteMovement.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteMovementStatus.data = action.payload;
        state.error = false;
      })
      .addCase(deleteMovement.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export const { setMovement } = movementSlice.actions;
export default movementSlice.reducer;
